<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>工单管理</el-breadcrumb-item>
        <el-breadcrumb-item>Dcops工单</el-breadcrumb-item>
        <el-breadcrumb-item>服务器故障</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="派单时间">
                <el-date-picker v-model="dispatchDateRange" type="daterange" range-separator="-" style="width: 100%"
                  start-placeholder="开始" end-placeholder="结束" value-format="yyyy-MM-dd"
                  @change="syncDispatchFromRange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结单时间">
                <el-date-picker v-model="completedDateRange" type="daterange" range-separator="-" style="width: 100%"
                  start-placeholder="开始" end-placeholder="结束" value-format="yyyy-MM-dd"
                  @change="syncCompletedFromRange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="超时时间">
                <el-date-picker v-model="olaDateRange" type="daterange" range-separator="-" style="width: 100%"
                  start-placeholder="开始" end-placeholder="结束" value-format="yyyy-MM-dd" @change="syncOlaFromRange" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24" class="time-filter-hint">
              以上三段时间为「且」关系；可不填。超时时间对应字段 olaTime（SLA 应完成时刻）。
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="工单号">
                <el-input v-model="searchForm.ticketId" placeholder="如 20260309045043" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="时效">
                <el-select v-model="searchForm.rd_olaTime" placeholder="按 SLA 与状态筛选" clearable>
                  <el-option label="预超时(在途且距 SLA≤2h)" value="1" />
                  <el-option label="超时-在途(SLA 已过)" value="2" />
                  <el-option label="超时-已结单(结单晚于 SLA)" value="3" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否超时">
                <el-select v-model="searchForm.isTimeOut" placeholder="全部" clearable>
                  <el-option label="是" value="是" />
                  <el-option label="否" value="否" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="故障单号">
                <el-input v-model="searchForm.instanceId" placeholder="实例 ID / 敜障单号" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="区域-园区">
                <el-select v-model="searchForm.campusName" placeholder="请选择" clearable filterable
                  @focus="handleSelectFocus">
                  <el-option v-for="item in campusOptions" :key="item" :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态">
                <el-select v-model="searchForm.state" placeholder="请选择" clearable>
                  <el-option label="已结单" value="已结单" />
                  <el-option label="运行中" value="运行中" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" />
            <el-col :span="6" />
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <div class="title-en">服务器故障列表</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button type="success" plain @click="openFaultUpdateMonthDialog">更新服务器列表</el-button>
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>
        <el-table ref="table" v-loading="loading" :data="showData" border stripe
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width" :align="column.align" :fixed="column.fixed"
            :show-overflow-tooltip="!column.thumbs && !!column.tooltip">
            <template slot-scope="scope">
              <template v-if="column.prop === 'ticketId'">
                <span v-if="scope.row.ticketId">{{ scope.row.ticketId }}</span>
                <span v-else>-</span>
              </template>
              <template v-else-if="column.prop === 'status'">
                <el-tag v-if="scope.row.status" :type="statusTagType(scope.row.status)" size="small">
                  {{ scope.row.status }}
                </el-tag>
                <span v-else>-</span>
              </template>
              <template v-else-if="column.prop === 'isTimeOut'">
                <el-tag v-if="scope.row.isTimeOut" :type="scope.row.isTimeOut === '是' ? 'danger' : 'success'"
                  size="small">{{ scope.row.isTimeOut }}</el-tag>
                <span v-else>-</span>
              </template>
              <template v-else-if="column.prop === 'lifeCycle'">
                <div class="life-cycle">
                  <div class="life-step">
                    <div class="life-dot" :class="{ on: !!scope.row.dispatchTime }" />
                    <div class="life-step-meta">
                      <div class="life-step-title">派单</div>
                      <div class="life-step-time">{{ formatLifeCycleTime(scope.row.dispatchTime) }}</div>
                    </div>
                  </div>
                  <div class="life-line" :class="{ on: !!scope.row.dispatchTime && !!scope.row.arriveIdcTime }" />

                  <div class="life-step">
                    <div class="life-dot" :class="{ on: !!scope.row.arriveIdcTime }" />
                    <div class="life-step-meta">
                      <div class="life-step-title">到达机房</div>
                      <div class="life-step-time">{{ formatLifeCycleTime(scope.row.arriveIdcTime) }}</div>
                    </div>
                  </div>
                  <div class="life-line" :class="{ on: !!scope.row.arriveIdcTime && !!scope.row.startOperateTime }" />

                  <div class="life-step">
                    <div class="life-dot" :class="{ on: !!scope.row.startOperateTime }" />
                    <div class="life-step-meta">
                      <div class="life-step-title">开始操作</div>
                      <div class="life-step-time">{{ formatLifeCycleTime(scope.row.startOperateTime) }}</div>
                    </div>
                  </div>
                  <div class="life-line" :class="{ on: !!scope.row.startOperateTime && !!scope.row.endOperateTime }" />

                  <div class="life-step">
                    <div class="life-dot" :class="{ on: !!scope.row.endOperateTime }" />
                    <div class="life-step-meta">
                      <div class="life-step-title">结束操作</div>
                      <div class="life-step-time">{{ formatLifeCycleTime(scope.row.endOperateTime) }}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="column.thumbs">
                <template v-if="column.prop === 'completedDesc' || column.prop === 'timeOutDesc'">
                  <div class="desc-cell">
                    <div v-if="column.copyable && descFullText(scope.row, column.prop) !== '-'" class="desc-cell-toolbar">
                      <el-button
                        type="text"
                        size="mini"
                        class="desc-cell-copy-btn"
                        title="复制本格全文"
                        icon="el-icon-document-copy"
                        @click.stop="copyCellByProp(scope.row, column.prop)"
                      />
                    </div>
                    <div v-if="imageUrlsForThumbColumn(scope.row, column).length" class="attach-thumb-wrap">
                      <el-image v-for="(u, idx) in imageUrlsForThumbColumn(scope.row, column).slice(0, 4)"
                        :key="'img-' + column.prop + '-' + idx" class="attach-thumb" :src="u"
                        :preview-src-list="imageUrlsForThumbColumn(scope.row, column)" fit="cover">
                        <div slot="error" class="attach-thumb-error">
                          <i class="el-icon-picture-outline" />
                        </div>
                      </el-image>
                      <el-popover v-if="imageUrlsForThumbColumn(scope.row, column).length > 4" placement="left"
                        width="340" trigger="click">
                        <div class="attach-popover-grid">
                          <el-image v-for="(u, idx) in imageUrlsForThumbColumn(scope.row, column).slice(4)"
                            :key="'pm-' + column.prop + '-' + idx" class="attach-thumb attach-thumb--sm" :src="u"
                            :preview-src-list="imageUrlsForThumbColumn(scope.row, column)" fit="cover">
                            <div slot="error" class="attach-thumb-error">
                              <i class="el-icon-picture-outline" />
                            </div>
                          </el-image>
                        </div>
                        <span slot="reference" class="attach-more-ref">
                          +{{ imageUrlsForThumbColumn(scope.row, column).length - 4 }}
                        </span>
                      </el-popover>
                    </div>

                    <el-tooltip effect="dark" placement="top-start" :content="descFullText(scope.row, column.prop)">
                      <div class="desc-text">
                        {{ descShortText(scope.row, column.prop) }}
                      </div>
                    </el-tooltip>
                  </div>
                </template>

                <template v-else>
                  <div v-if="!urlCountForThumbs(scope.row, column)" class="attach-empty">
                    <span v-if="column.thumbsFromHtml" class="thumb-text-fallback">{{
                      textFallbackForThumbColumn(scope.row, column.prop) }}</span>
                    <span v-else>-</span>
                  </div>
                  <div v-else class="attach-thumb-wrap">
                    <template v-for="(u, idx) in urlsForThumbs(scope.row, column).slice(0, 4)">
                      <el-image v-if="isImageUrl(u)" :key="'img-' + column.prop + '-' + idx" class="attach-thumb"
                        :src="u" :preview-src-list="imageUrlsForThumbColumn(scope.row, column)" fit="cover">
                        <div slot="error" class="attach-thumb-error">
                          <i class="el-icon-picture-outline" />
                        </div>
                      </el-image>
                      <a v-else :key="'file-' + column.prop + '-' + idx" class="attach-file-chip" :href="u"
                        target="_blank" rel="noopener" title="打开附件">
                        <i class="el-icon-document" />
                      </a>
                    </template>
                    <el-popover v-if="urlsForThumbs(scope.row, column).length > 4" placement="left" width="340"
                      trigger="click">
                      <div class="attach-popover-grid">
                        <template v-for="(u, idx) in urlsForThumbs(scope.row, column).slice(4)">
                          <el-image v-if="isImageUrl(u)" :key="'pm-' + column.prop + '-' + idx"
                            class="attach-thumb attach-thumb--sm" :src="u"
                            :preview-src-list="imageUrlsForThumbColumn(scope.row, column)" fit="cover">
                            <div slot="error" class="attach-thumb-error">
                              <i class="el-icon-picture-outline" />
                            </div>
                          </el-image>
                          <a v-else :key="'pf-' + column.prop + '-' + idx" class="attach-file-chip attach-file-chip--sm"
                            :href="u" target="_blank" rel="noopener" title="打开附件">
                            <i class="el-icon-document" />
                          </a>
                        </template>
                      </div>
                      <span slot="reference" class="attach-more-ref">
                        +{{ urlsForThumbs(scope.row, column).length - 4 }}
                      </span>
                    </el-popover>
                  </div>
                </template>
              </template>
              <template v-else-if="column.prop === 'faultDesc'">
                <div class="fault-desc-with-copy">
                  <el-tooltip effect="dark" placement="top-start" :content="formatCell(scope.row, column.prop)">
                    <span class="fault-desc-text">{{ formatCell(scope.row, column.prop) }}</span>
                  </el-tooltip>
                  <el-button
                    v-if="hasCopyableFaultDesc(scope.row)"
                    type="text"
                    size="mini"
                    class="fault-desc-copy-btn"
                    title="复制本格内容"
                    icon="el-icon-document-copy"
                    @click.stop="copyCellByProp(scope.row, 'faultDesc')"
                  />
                </div>
              </template>
              <span v-else>{{ formatCell(scope.row, column.prop) }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="选择月份范围" :visible.sync="monthSelectDialogVisible" :append-to-body="true" width="700px"
          :close-on-click-modal="false" custom-class="month-select-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-form :model="monthSelectForm" label-width="100px">
            <el-form-item label="开始月份">
              <el-date-picker v-model="monthSelectForm.startMonth" type="month" placeholder="选择开始月份" format="yyyy-MM"
                value-format="yyyy-MM" style="width: 100%" />
            </el-form-item>
            <el-form-item label="结束月份">
              <el-date-picker v-model="monthSelectForm.endMonth" type="month" placeholder="选择结束月份" format="yyyy-MM"
                value-format="yyyy-MM" style="width: 100%" />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="monthSelectDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmFaultMonthSelect">确定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="400px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getDcopsFaultCampusOptions,
  getServerFaultList,
  UpdateServerFaultList,
} from '@/api/dcopsTicket';
import { debounce } from 'lodash';
import * as XLSX from 'xlsx';

const DATE_PROPS = [
  'dispatchTime',
  'olaTime',
  'completedTime',
  'arriveIdcTime',
  'startOperateTime',
  'endOperateTime',
];

const HTML_TEXT_PROPS = ['completedDesc', 'timeOutDesc'];

function stripHtml(raw) {
  if (raw === null || raw === undefined) return '';
  const s = String(raw);
  return s
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/g, '&')
    .replace(/\s+/g, ' ')
    .trim();
}

export default {
  name: 'DcopsServerFault',
  data() {
    const cols = [
      { prop: 'ticketId', label: '工单号', width: 160 },
      { prop: 'instanceId', label: '故障单号/实例ID', width: 160 },
      { prop: 'scene', label: '工单场景', width: 120 },
      { prop: 'status', label: '工单状态', width: 100 },
      { prop: 'faultType', label: '故障类型', width: 120 },
      { prop: 'handler', label: '当前处理人', width: 110 },
      { prop: 'completedUser', label: '结单人', width: 100 },
      { prop: 'olaTime', label: '超时时间', width: 160 },
      { prop: 'olaLevel', label: '工单级别', width: 100 },
      { prop: 'isTimeOut', label: '是否超时', width: 90 },
      { prop: 'campusName', label: '园区', width: 120 },
      { prop: 'idcpName', label: '一级机房', width: 140 },
      { prop: 'idcName', label: '机房管理单元', width: 140 },
      { prop: 'rackName', label: '机架', width: 100 },
      { prop: 'posName', label: '机位', width: 100 },
      { prop: 'sn', label: 'SN', width: 140 },
      { prop: 'assetId', label: '固资号', width: 120 },
      { prop: 'model', label: '机型', width: 120 },
      { prop: 'maintenanceStatus', label: '维保状态', width: 100 },
      { prop: 'taskType', label: '工单类型', width: 110 },
      { prop: 'operateScene', label: '处理场景', width: 120 },
      { prop: 'completedTime', label: '结单时间', width: 160 },
      { prop: 'lifeCycle', label: '工单生命周期', width: 450 },

      { prop: 'completedDesc', label: '结单描述', width: 236, thumbs: true, thumbsFromHtml: true, copyable: true },
      { prop: 'timeOutDesc', label: '超时描述', width: 236, thumbs: true, thumbsFromHtml: true, copyable: true },
      { prop: 'isTimeTail', label: '是否尾单', width: 90 },
      { prop: 'attachments', label: '结单附件', width: 236, thumbs: true },
      { prop: 'timeoutImgs', label: '超时举证图片', width: 236, thumbs: true },

      { prop: 'faultDesc', label: '故障描述', width: 220, tooltip: true, copyable: true },
    ];
    const defaultSel = [
      'ticketId',
      'instanceId',
      // 'scene',
      'status',
      // 'faultType',
      'faultDesc',
      'handler',
      'completedUser',
      'olaTime',
      'isTimeOut',
      'campusName',
      'idcpName',
      // 'sn',
      'attachments',
      'timeoutImgs',
      'completedDesc',
      'timeOutDesc',
      'lifeCycle',
    ];
    return {
      monthSelectDialogVisible: false,
      monthSelectForm: {
        startMonth: this.$moment().subtract(1, 'month').format('YYYY-MM'),
        endMonth: this.$moment().format('YYYY-MM'),
      },
      showColumnsDialog: false,
      campusOptions: [],
      hasLoaded: false,
      dispatchDateRange: [],
      completedDateRange: [],
      olaDateRange: [],
      columns: cols,
      selectedColumns: [...defaultSel],
      defaultSelectedColumns: [...defaultSel],
      visibleColumns: [],
      selectedRows: [],
      showData: [],
      searchForm: {
        start_time: null,
        end_time: null,
        completedStartTime: null,
        completedEndTime: null,
        olaStartTime: null,
        olaEndTime: null,
        ticketId: '',
        instanceId: '',
        campusName: '',
        state: '',
        isTimeOut: '',
        rd_olaTime: '',
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      exportLoading: false,
    };
  },
  created() {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.dispatchDateRange = [
      this.$moment(startDate).format('YYYY-MM-DD'),
      this.$moment(endDate).format('YYYY-MM-DD'),
    ];
    this.syncDispatchFromRange(this.dispatchDateRange);
    this.completedDateRange = [];
    this.olaDateRange = [];
    this.visibleColumns = this.columns.filter((column) => this.selectedColumns.includes(column.prop));
    this.fetchList();
    this.getCampusData();
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    openFaultUpdateMonthDialog() {
      this.monthSelectDialogVisible = true;
    },
    confirmFaultMonthSelect() {
      if (!this.monthSelectForm.startMonth || !this.monthSelectForm.endMonth) {
        this.$message.warning('请选择开始月份和结束月份');
        return;
      }
      const start = this.$moment(this.monthSelectForm.startMonth, 'YYYY-MM');
      const end = this.$moment(this.monthSelectForm.endMonth, 'YYYY-MM');
      if (end.isBefore(start)) {
        this.$message.warning('结束月份不能早于开始月份');
        return;
      }
      this.monthSelectDialogVisible = false;
      const params = {
        start_month: this.monthSelectForm.startMonth,
        end_month: this.monthSelectForm.endMonth,
      };
      this.loading = true;
      UpdateServerFaultList(params)
        .then((res) => {
          this.loading = false;
          const body = res && res.data;
          if (body && body.code === 200) {
            const inner = body.data || {};
            const stats = inner.data || {};
            const parts = [
              inner.msg,
              stats.rows_saved != null ? `累计处理工单条数: ${stats.rows_saved}` : '',
              stats.error_count != null ? `失败请求数: ${stats.error_count}` : '',
              stats.elapsed_sec != null ? `耗时 ${stats.elapsed_sec}s` : '',
              stats.start_month && stats.end_month ? `月份: ${stats.start_month} ~ ${stats.end_month}` : '',
            ].filter(Boolean);
            this.$message.success(parts.join('；') || '同步完成');
            this.fetchList();
            this.getCampusData();
          } else {
            this.$message.error((body && body.message) || '同步失败');
          }
        })
        .catch((err) => {
          console.error(err);
          this.$message.error('同步请求失败');
          this.loading = false;
        });
    },
    async getCampusData() {
      try {
        const response = await getDcopsFaultCampusOptions();
        if (response.data && response.data.code === 200) {
          const raw = (response.data.data && response.data.data.campus_list) || [];
          this.campusOptions = Array.from(new Set(raw.filter(Boolean)));
          this.hasLoaded = true;
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    syncDispatchFromRange(val) {
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        this.searchForm.start_time = val[0];
        this.searchForm.end_time = `${val[1]} 23:59:59`;
      } else {
        this.searchForm.start_time = null;
        this.searchForm.end_time = null;
      }
    },
    syncCompletedFromRange(val) {
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        this.searchForm.completedStartTime = val[0];
        this.searchForm.completedEndTime = `${val[1]} 23:59:59`;
      } else {
        this.searchForm.completedStartTime = null;
        this.searchForm.completedEndTime = null;
      }
    },
    syncOlaFromRange(val) {
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        this.searchForm.olaStartTime = val[0];
        this.searchForm.olaEndTime = `${val[1]} 23:59:59`;
      } else {
        this.searchForm.olaStartTime = null;
        this.searchForm.olaEndTime = null;
      }
    },
    statusTagType(status) {
      const s = String(status || '');
      if (s === '已结单' || s === '完成') return 'success';
      if (s === '运行中' || s === '进行中') return 'warning';
      if (s === '驳回') return 'info';
      return '';
    },
    splitUrls(raw) {
      if (!raw || typeof raw !== 'string') return [];
      return raw
        .split(';')
        .map((u) => u.trim())
        .filter(Boolean);
    },
    urlCount(raw) {
      return this.splitUrls(raw).length;
    },
    extractImageUrlsFromHtml(html) {
      if (!html || typeof html !== 'string') return [];
      const seen = new Set();
      const out = [];
      const add = (u) => {
        let t = (u || '').trim().replace(/&amp;/g, '&');
        if (!t || seen.has(t)) return;
        seen.add(t);
        out.push(t);
      };
      const imgRe = /<img[^>]+src\s*=\s*["']([^"']+)["']/gi;
      let m;
      while ((m = imgRe.exec(html)) !== null) add(m[1]);
      const plainRe = /https?:\/\/[^\s<>"']+\.(?:jpe?g|png|gif|webp|bmp)(?:\?[^\s<>"']*)?/gi;
      while ((m = plainRe.exec(html)) !== null) add(m[0]);
      return out;
    },
    urlsForThumbs(row, column) {
      const raw = row[column.prop];
      if (raw === null || raw === undefined || raw === '') return [];
      if (column.thumbsFromHtml) {
        const fromHtml = this.extractImageUrlsFromHtml(String(raw));
        const fromSemi = this.splitUrls(String(raw));
        const seen = new Set();
        const merged = [];
        for (const u of [...fromHtml, ...fromSemi]) {
          const t = (u || '').trim();
          if (!t || seen.has(t)) continue;
          seen.add(t);
          merged.push(t);
        }
        return merged;
      }
      return this.splitUrls(String(raw));
    },
    urlCountForThumbs(row, column) {
      return this.urlsForThumbs(row, column).length;
    },
    imageUrlsForThumbColumn(row, column) {
      return this.urlsForThumbs(row, column).filter((x) => this.isImageUrl(x));
    },
    textFallbackForThumbColumn(row, prop) {
      const v = row[prop];
      if (v === '' || v === null || v === undefined) return '-';
      const t = stripHtml(String(v));
      if (!t) return '-';
      return t.length > 80 ? `${t.slice(0, 80)}…` : t;
    },
    isImageUrl(u) {
      if (!u || typeof u !== 'string') return false;
      const path = u.split('?')[0].split('#')[0].toLowerCase();
      return /\.(jpe?g|png|gif|webp|bmp|svg)$/.test(path);
    },
    stripHtmlToTextWithBreaks(raw) {
      if (raw === null || raw === undefined) return '';
      let s = String(raw);
      s = s.replace(/<br\s*\/?>/gi, '\n');
      s = s.replace(/<\/p>/gi, '\n');
      s = s.replace(/<p[^>]*>/gi, '');
      s = s.replace(/&nbsp;/gi, ' ');
      s = s.replace(/&amp;/gi, '&');
      // 其它标签直接去掉，保留我们注入的换行
      s = s.replace(/<[^>]+>/g, '');
      // 统一空白（保留 \n）
      s = s
        .split('\n')
        .map((line) => line.replace(/\s+/g, ' ').trim())
        .filter((line) => line !== '')
        .join('\n');
      return s.trim();
    },
    descFullText(row, prop) {
      const v = row ? row[prop] : null;
      const t = this.stripHtmlToTextWithBreaks(v);
      return t || '-';
    },
    descShortText(row, prop) {
      const t = this.descFullText(row, prop);
      if (t === '-') return '-';
      return t.length > 160 ? `${t.slice(0, 160)}…` : t;
    },
    hasCopyableFaultDesc(row) {
      const v = row && row.faultDesc;
      if (v === null || v === undefined) return false;
      const t = stripHtml(String(v)).trim();
      return t.length > 0;
    },
    getCopyablePlainText(row, prop) {
      if (prop === 'completedDesc' || prop === 'timeOutDesc') {
        const t = this.descFullText(row, prop);
        return t === '-' ? '' : t;
      }
      if (prop === 'faultDesc') {
        const v = row && row.faultDesc;
        if (v === null || v === undefined) return '';
        return stripHtml(String(v)).replace(/\s+/g, ' ').trim();
      }
      return '';
    },
    _fallbackCopyText(text) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', 'readonly');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
      } finally {
        document.body.removeChild(ta);
      }
    },
    copyCellByProp(row, prop) {
      const text = this.getCopyablePlainText(row, prop);
      if (!text) {
        this.$message.warning('无可复制内容');
        return;
      }
      const done = () => this.$message.success('已复制到剪贴板');
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard
          .writeText(text)
          .then(done)
          .catch(() => {
            try {
              this._fallbackCopyText(text);
              done();
            } catch (e) {
              this.$message.error('复制失败');
            }
          });
      } else {
        try {
          this._fallbackCopyText(text);
          done();
        } catch (e) {
          this.$message.error('复制失败');
        }
      }
    },
    formatLifeCycleTime(val) {
      if (!val) return '-';
      const m = this.$moment(val);
      return m.isValid() ? m.format('MM-DD HH:mm') : String(val);
    },
    lifeCycleExportText(row) {
      const fmt = (v) => {
        if (!v) return '-';
        const m = this.$moment(v);
        return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : String(v);
      };
      return `派单:${fmt(row.dispatchTime)}；到达机房:${fmt(row.arriveIdcTime)}；开始操作:${fmt(row.startOperateTime)}；结束操作:${fmt(
        row.endOperateTime
      )}`;
    },
    fetchList() {
      this.loading = true;
      const rawParams = {
        page: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
      };
      const params = Object.fromEntries(
        Object.entries(rawParams).filter(([, value]) => {
          if (value === '' || value === null || value === undefined) return false;
          if (Array.isArray(value) && value.length === 0) return false;
          return true;
        }),
      );
      getServerFaultList(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.showData = res.data.data.data || [];
            this.total = res.data.data.total || 0;
          } else {
            this.$message.error(res.data.message || res.msg || '获取列表失败');
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error('获取列表失败:', err);
          this.$message.error('获取列表失败');
          this.loading = false;
        });
    },
    formatCell(row, prop) {
      const v = row ? row[prop] : undefined;
      if (v === '' || v === null || v === undefined) return '-';
      if (DATE_PROPS.includes(prop)) {
        const m = this.$moment(v);
        return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : String(v);
      }
      if (HTML_TEXT_PROPS.includes(prop)) {
        const t = stripHtml(v);
        return t || '-';
      }
      return String(v);
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchList();
    },
    handleReset() {
      const now = new Date();
      const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const range = [
        this.$moment(startDate).format('YYYY-MM-DD'),
        this.$moment(endDate).format('YYYY-MM-DD'),
      ];
      this.dispatchDateRange = range;
      this.completedDateRange = [];
      this.olaDateRange = [];
      this.searchForm = {
        start_time: null,
        end_time: null,
        completedStartTime: null,
        completedEndTime: null,
        olaStartTime: null,
        olaEndTime: null,
        ticketId: '',
        instanceId: '',
        campusName: '',
        state: '',
        isTimeOut: '',
        rd_olaTime: '',
      };
      this.syncDispatchFromRange(range);
      this.syncCompletedFromRange(null);
      this.syncOlaFromRange(null);
      this.currentPage = 1;
      this.fetchList();
    },
    async handleExport() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      this.loading = true;
      const sheetName = '服务器故障列表';
      try {
        // 导出列：将“工单生命周期(lifeCycle)”展开成正常的四个字段
        const exportFields = [];
        this.visibleColumns.forEach((column) => {
          if (column.prop === 'lifeCycle') {
            exportFields.push({ label: '派单时间', prop: 'dispatchTime', width: 160 });
            exportFields.push({ label: '到达机房时间', prop: 'arriveIdcTime', width: 160 });
            exportFields.push({ label: '开始操作时间', prop: 'startOperateTime', width: 160 });
            exportFields.push({ label: '结束操作时间', prop: 'endOperateTime', width: 160 });
            return;
          }
          exportFields.push({
            label: column.label,
            prop: column.prop,
            width: column.width || 10,
          });
        });

        const formatByProp = (prop, value) => {
          if (value === '' || value === null || value === undefined) return '-';
          let v = value;
          if (DATE_PROPS.includes(prop) && v) {
            const m = this.$moment(v);
            v = m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : v;
          } else if (HTML_TEXT_PROPS.includes(prop) && v) {
            v = stripHtml(v);
          }
          return v === '' || v === null || v === undefined ? '-' : v;
        };

        const buildRows = (rows) =>
          rows.map((row) => {
            const rowData = {};
            exportFields.forEach((field) => {
              rowData[field.label] = formatByProp(field.prop, row[field.prop]);
            });
            return rowData;
          });

        if (this.selectedRows.length === 0) {
          const params = {
            export_excel: '1',
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([key, value]) => value !== '' && value !== null && value !== undefined,
              ),
            ),
          };
          const response = await getServerFaultList(params);
          if (response.data && response.data.code === 200) {
            const allData = response.data?.data?.data || [];
            const worksheetData = buildRows(allData);
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);
            const colWidths = {};
            exportFields.forEach((field, index) => {
              const width = field.width ? Math.ceil(parseInt(field.width, 10) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            XLSX.writeFile(workbook, `${sheetName}_${timestamp}.xlsx`);
            this.$message.success('导出成功');
          }
        } else {
          const worksheetData = buildRows(this.selectedRows);
          const worksheet = XLSX.utils.json_to_sheet(worksheetData);
          const colWidths = {};
          exportFields.forEach((field, index) => {
            const width = field.width ? Math.ceil(parseInt(field.width, 10) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          XLSX.writeFile(workbook, `${sheetName}_${timestamp}.xlsx`);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) => this.selectedColumns.includes(column.prop));
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchList();
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 10px;
}

.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 360px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

.time-filter-hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin: -8px 0 8px;
  padding-left: 8px;
}

.attach-empty {
  color: #c0c4cc;
}

.thumb-text-fallback {
  display: block;
  color: #606266;
  font-size: 12px;
  line-height: 1.4;
  word-break: break-word;
}

.attach-thumb-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 2px 0;
}

.attach-thumb {
  width: 44px;
  height: 44px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ebeef5;
  flex-shrink: 0;
  overflow: hidden;
}

.attach-thumb ::v-deep .el-image__inner {
  border-radius: 3px;
}

.attach-thumb-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #c0c4cc;
  font-size: 18px;
}

.attach-file-chip {
  width: 44px;
  height: 44px;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 20px;
  flex-shrink: 0;
  text-decoration: none;
}

.attach-file-chip:hover {
  border-color: #409eff;
  background: #ecf5ff;
}

.attach-more-ref {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 44px;
  padding: 0 8px;
  background: #f4f4f5;
  color: #606266;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  flex-shrink: 0;
  user-select: none;
}

.attach-more-ref:hover {
  background: #e9e9eb;
}

.attach-popover-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 280px;
  overflow-y: auto;
}

.desc-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.desc-cell-toolbar {
  display: flex;
  justify-content: flex-end;
  margin: -2px 0 0;
}

.desc-cell-copy-btn,
.fault-desc-copy-btn {
  padding: 0 4px !important;
  min-width: auto !important;
  color: #909399;
}

.desc-cell-copy-btn:hover,
.fault-desc-copy-btn:hover {
  color: #409eff;
}

.fault-desc-with-copy {
  display: flex;
  align-items: flex-start;
  gap: 2px;
  max-width: 100%;
}

.fault-desc-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: #606266;
}

.desc-text {
  white-space: pre-line;
  line-height: 1.4;
  color: #606266;
  font-size: 12px;
  max-width: 220px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
}

.life-cycle {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0;
  min-width: 450px;
}

.life-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70px;
}

.life-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #dcdfe6;
  box-sizing: border-box;
}

.life-dot.on {
  background: #67c23a;
  box-shadow: 0 0 0 3px rgba(103, 194, 58, 0.15);
}

.life-step-meta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}

.life-step-title {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}

.life-step-time {
  font-size: 12px;
  color: #303133;
  white-space: nowrap;
}

.life-line {
  width: 26px;
  height: 4px;
  border-radius: 2px;
  background: #ebeef5;
  flex-shrink: 0;
}

.life-line.on {
  background: #67c23a;
}

.attach-thumb--sm {
  width: 56px;
  height: 56px;
}

.attach-file-chip--sm {
  width: 56px;
  height: 56px;
}
</style>
